import { isPresent } from 'utils/isPresent';
import {getFormValues, change, reset} from 'redux-form';
import { receivedServerData } from "../../../Common/Data/DataFetcher.js"
import { MANUAL_ENTRY, trackCustomerAdded } from "../../../Services/Analytics/TrackEventsService.js"
import CustomerApi from "../../api/CustomersApi";
import {showErrorDialog} from "../../../Common/CommonActions.js";
import {
    emailFormValidator, fieldLengthFormValidator,
    phoneNumberFormValidator,
    validatePresence
} from "../../../Common/Form/FormValidations";
import { pickBy, identity } from 'lodash-es'

export const CUSTOMER_CONTACT_INFO_FORM = 'CUSTOMER_CONTACT_INFO_FORM';
export const CUSTOMER_INFO_FORM = 'CUSTOMER_INFO_FORM';
export const FTU_CUSTOMER_INFO_FORM = 'FTU_CUSTOMER_INFO_FORM';
export const OPEN_EDIT_CUSTOMER_DIALOG = 'OPEN_EDIT_CUSTOMER_DIALOG';
export const CLEAR_CUSTOMER_INITIAL_FIELDS = 'CLEAR_CUSTOMER_INITIAL_FIELDS';
export const SHOW_ADD_OR_EDIT_CUSTOMER_SPINNER = 'SHOW_ADD_OR_EDIT_CUSTOMER_SPINNER';
export const UPDATE_ADDRESS_COUNTRY = 'UPDATE_ADDRESS_COUNTRY';
export const ALLOW_ADDRESS_ROW_CLICK = 'ALLOW_ADDRESS_ROW_CLICK';

export const ADD_CUSTOMER_TAGS = 'ADD_CUSTOMER_TAGS';
export const DELETE_CUSTOMER_TAGS = 'DELETE_CUSTOMER_TAGS';
export const UPDATE_PARENT_CUSTOMER = 'UPDATE_PARENT_CUSTOMER';
export const UPDATE_BILLING_ADDRESS_INDEX = 'UPDATE_BILLING_ADDRESS_INDEX';
export const UPDATE_EXPANDED_ADDRESS = 'UPDATE_EXPANDED_ADDRESS';

export function clearCustomerInitialFields() {
    return dispatch => {
        dispatch({type: CLEAR_CUSTOMER_INITIAL_FIELDS});
        dispatch(reset(CUSTOMER_INFO_FORM))
    }
}

function addressIsValid(address) {
    return isPresent(address) && !(Object.keys(address).length === 1 && Object.keys(address)[0] === 'billing')
}

export function addAdditionalEmails(namespace) {
    return (dispatch, getState) => {
        dispatch(change(namespace, 'additional_emails', (getFormValues(namespace)(getState()).additional_emails || []).concat({})))
    }
}

export function addAdditionalPhones(namespace) {
    return (dispatch, getState) => {
        dispatch(change(namespace, 'additional_phone_numbers', (getFormValues(namespace)(getState()).additional_phone_numbers || []).concat({})))
    }
}

export function updateBillingAddress(preIndex, currentIndex) {
    return (dispatch, getState) => {
        if (getState().addOrEditCustomer.billingAddressIndex === preIndex) {
            dispatch({type: UPDATE_BILLING_ADDRESS_INDEX, index: currentIndex})
        }
    }
}

export function onRemoveAddress(index) {
    return (dispatch, getState) => {
        dispatch({type: UPDATE_EXPANDED_ADDRESS, key: false});

        if (getState().addOrEditCustomer.billingAddressIndex === index) {
            dispatch({type: UPDATE_BILLING_ADDRESS_INDEX, index: -1})
        }
    }
}

export function toggleCustomerDialog(status) {
  return receivedServerData({open: status}, 'CUSTOMER_DIALOG_NAMESPACE')
}

export function onSubmit(values, dispatch, props, isSample = false) {
  const onSuccessCallback = (response) => {
    if (props.action === 'create') {
      dispatch(trackCustomerAdded(MANUAL_ENTRY, {
        is_contractor: values.is_contractor,
        is_sample: isSample,
        prequal_sent: values.wisetack_prequal_application
      }));
    }
    props.onSuccess(response.data.customer, `/pro/customers/${response.data.customer.id}`)
  }

  dispatch(createOrUpdateCustomer(values, onSuccessCallback, props.onFailure))
    .then(() => {
      if (props.close) {
        props.close()
      }
    }).catch((error) => {
    dispatch(showErrorDialog(error))
    props.onFailure(error)
  })
  dispatch(clearCustomerInitialFields())
}

export function createOrUpdateCustomer(values, onSuccessCallback, onFailure = (error) => {}) {
    return (dispatch, getState) => {
        const {parentCustomer, customerTags, billingAddressIndex} = getState().addOrEditCustomer || {};
        let hasParentAddress = isPresent(parentCustomer) && isPresent(parentCustomer.all_addresses);

        if (isPresent(parentCustomer) && parentCustomer.id >= 0) {
            values['parent_id'] = parentCustomer.id
        } else {
            values['parent_id'] = null
        }

        if (isPresent(customerTags)) {
            values['tags'] = customerTags
        } else {
            values['tags'] = []
        }

        let serviceAddresses = values['service_addresses'];

        if (isPresent(serviceAddresses)) {
            values['service_addresses'] = serviceAddresses.filter((address, index) => (
                !(index === 0 && hasParentAddress) && addressIsValid(address))
            );
            values['service_addresses'].map((address, index) => {
                address['order_index'] = index;
                address['billing'] = !hasParentAddress && index === billingAddressIndex;
            })
        }

        let additionalEmails = values['additional_emails'];

        if (isPresent(additionalEmails)) {
            values['additional_emails'] = additionalEmails.filter(email => isPresent(email['email']));
        }

        const leadSource = values['lead_source']

        if (isPresent(leadSource)) {
            values['lead_source_uuid'] = leadSource.uuid;
        }

        return CustomerApi.createOrUpdateCustomer(values)
            .then(response => {
              return onSuccessCallback(response)
            })
            .catch(error => {
                if (error.response) {
                   throw error.response.data.error
                }
                onFailure(error)
            })
    }
}

export function getCompanyCountry(defaultCountry) {
    return dispatch => {
        CustomerApi.getCompanyCountry().then(response => {
            if (isPresent(response.data.country) && response.data.country !== defaultCountry) {
                dispatch({type: UPDATE_ADDRESS_COUNTRY, country: response.data.country})
            }
        })
    }
}

export const validate = (values) => {
    const errors = {};

    errors.first_name = fieldLengthFormValidator(values.first_name, 255)
    errors.last_name = fieldLengthFormValidator(values.last_name, 255)
    if(values.display_name != null)
        errors.display_name = validatePresence(values.display_name) || fieldLengthFormValidator(values.display_name, 191)
    errors.company = fieldLengthFormValidator(values.company, 255)
    errors.job_title = fieldLengthFormValidator(values.job_title, 255)
    errors.notes = fieldLengthFormValidator(values.notes, 65535)

    errors.mobile_number = phoneNumberFormValidator(values.mobile_number)
    errors.home_number = phoneNumberFormValidator(values.home_number)
    errors.work_number = phoneNumberFormValidator(values.work_number)

    errors.email = emailFormValidator(values.email)

    if (isPresent(values.additional_phone_numbers)) {
        errors.additional_phone_numbers = [];
        values.additional_phone_numbers.forEach(value => {
            let errorText = phoneNumberFormValidator(value.phone_number)
            let noteErrorText = fieldLengthFormValidator(value.notes, 40)
            errors.additional_phone_numbers.push({phone_number: errorText, notes: noteErrorText})
        })
    }

    if(isPresent(values.additional_emails)){
        errors.additional_emails = [];
        values.additional_emails.forEach(emailHash => {
            let errorText = '';
            if (isPresent(emailHash)) {
                errorText = emailFormValidator(emailHash['email'])
            }
            errors.additional_emails.push({email: errorText})
        })
    }

    if (isPresent(values.service_addresses)) {
        errors.service_addresses = values.service_addresses.map(address => ({
            notes: fieldLengthFormValidator(address.notes, 65535)
        }))
    }

    if (values.wisetack_prequal_application && !values.mobile_number) {
        errors.mobile_number = 'Required';
        errors.wisetack_prequal_application = 'Please provide mobile phone to send';
    }

    let errorsCleaned = pickBy(errors, identity)

    return errorsCleaned
}
